import React from 'react';
import { CheckCircle2 } from 'lucide-react';

export function AccessibilityFeatures() {
  return (
    <div className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-8 rounded-lg shadow-lg">
      <div className="flex items-center gap-4 mb-6">
        <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
          <CheckCircle2 className="w-6 h-6 text-accessible-red-600" aria-hidden="true" />
        </div>
        <h2 className="card-title">
          Funkcje dostępności
        </h2>
      </div>
      
      <div className="space-y-4">
        <p className="body-medium">
          Strona internetowa Fundacji Znajdki posiada następujące funkcje dostępności:
        </p>
        <ul className="space-y-3">
          <li className="flex items-start gap-2">
            <CheckCircle2 className="w-5 h-5 text-accessible-red-600 flex-shrink-0 mt-1" />
            <div>
              <strong className="block label-large">Tryb ciemny (Dark Mode)</strong>
              <span className="body-medium no-margin">Możliwość przełączenia strony w tryb ciemny, który zmniejsza zmęczenie oczu i jest bardziej komfortowy przy słabym oświetleniu</span>
            </div>
          </li>
          <li className="flex items-start gap-2">
            <CheckCircle2 className="w-5 h-5 text-accessible-red-600 flex-shrink-0 mt-1" />
            <div>
              <strong className="block label-large">Tryb wysokiego kontrastu</strong>
              <span className="body-medium no-margin">Zwiększony kontrast między tekstem a tłem (czarne tło, biały tekst) dla osób z wadami wzroku i zaburzeniami widzenia kolorów</span>
            </div>
          </li>
          <li className="flex items-start gap-2">
            <CheckCircle2 className="w-5 h-5 text-accessible-red-600 flex-shrink-0 mt-1" />
            <div>
              <strong className="block label-large">Zmiana rozmiaru tekstu</strong>
              <span className="body-medium no-margin">Możliwość powiększenia lub zmniejszenia rozmiaru tekstu na stronie (od 80% do 300%) za pomocą przycisków lub skrótów klawiaturowych</span>
            </div>
          </li>
          <li className="flex items-start gap-2">
            <CheckCircle2 className="w-5 h-5 text-accessible-red-600 flex-shrink-0 mt-1" />
            <div>
              <strong className="block label-large">Nawigacja klawiaturą</strong>
              <span className="body-medium no-margin">Możliwość poruszania się po stronie za pomocą klawiatury z wyraźnie widocznym fokusem na aktywnych elementach</span>
            </div>
          </li>
          <li className="flex items-start gap-2">
            <CheckCircle2 className="w-5 h-5 text-accessible-red-600 flex-shrink-0 mt-1" />
            <div>
              <strong className="block label-large">Alternatywne opisy obrazów</strong>
              <span className="body-medium no-margin">Wszystkie istotne obrazy posiadają alternatywne opisy (atrybuty alt) dla czytników ekranu</span>
            </div>
          </li>
          <li className="flex items-start gap-2">
            <CheckCircle2 className="w-5 h-5 text-accessible-red-600 flex-shrink-0 mt-1" />
            <div>
              <strong className="block label-large">Semantyczna struktura HTML</strong>
              <span className="body-medium no-margin">Prawidłowe użycie nagłówków, list i innych elementów strukturalnych dla lepszej nawigacji</span>
            </div>
          </li>
          <li className="flex items-start gap-2">
            <CheckCircle2 className="w-5 h-5 text-accessible-red-600 flex-shrink-0 mt-1" />
            <div>
              <strong className="block label-large">Oznaczenia ARIA</strong>
              <span className="body-medium no-margin">Dodatkowe atrybuty ARIA dla lepszej kompatybilności z technologiami wspomagającymi</span>
            </div>
          </li>
          <li className="flex items-start gap-2">
            <CheckCircle2 className="w-5 h-5 text-accessible-red-600 flex-shrink-0 mt-1" />
            <div>
              <strong className="block label-large">Komunikaty dla czytników ekranu</strong>
              <span className="body-medium no-margin">Dynamiczne komunikaty dla czytników ekranu przy zmianach stanu interfejsu</span>
            </div>
          </li>
          <li className="flex items-start gap-2">
            <CheckCircle2 className="w-5 h-5 text-accessible-red-600 flex-shrink-0 mt-1" />
            <div>
              <strong className="block label-large">Responsywny design</strong>
              <span className="body-medium no-margin">Dostosowanie do różnych urządzeń i rozmiarów ekranu</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}